function AtRiskPlans({ session, onNavigate, atRiskOpps, onOpenBidPlan }) {
  if (!atRiskOpps || atRiskOpps.length === 0) {
    return (
      <div className="scorecard-page container">
        <div className="page-header">
          <p className="label">Milestones At Risk / Missed</p>
          <h1>All Clear</h1>
          <p>No milestones are currently at risk, missed, or overdue across any active bid plans.</p>
        </div>
        <div className="card">
          <p style={{ color: 'var(--slate)', textAlign: 'center', padding: '32px 0' }}>
            Everything is on track. Well done.
          </p>
        </div>
        <div className="actions">
          <button className="btn btn--secondary" onClick={() => onNavigate('dashboard')}>
            ← Dashboard
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="scorecard-page container">
      <div className="page-header">
        <p className="label">Milestones At Risk / Missed</p>
        <h1>Bids Requiring Attention</h1>
        <p>
          The following bids have milestones that are at risk, missed, or overdue.
          Click any bid to open its Gantt plan directly.
        </p>
      </div>

      {atRiskOpps.map(opp => (
        <div
          key={opp.id}
          className="card"
          style={{
            cursor: 'pointer', marginBottom: '12px',
            borderLeft: '4px solid var(--red)',
            transition: 'box-shadow 0.2s'
          }}
          onClick={() => {
            if (opp.plan) {
              onOpenBidPlan({ ...opp, planId: opp.plan.id })
            } else {
              onNavigate('bidplan')
            }
          }}
          onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 20px rgba(192,57,43,0.15)'}
          onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: '1.25rem', fontWeight: 600,
                color: 'var(--green-dark)', marginBottom: '4px'
              }}>
                {opp.title}
              </div>
              <div style={{ fontSize: '0.875rem', color: 'var(--slate)' }}>
                {opp.buyer}
                {opp.plan?.submission_deadline && (
                  <span style={{ marginLeft: '12px' }}>
                    Submission: {new Date(opp.plan.submission_deadline).toLocaleDateString('en-GB', {
                      day: 'numeric', month: 'short', year: 'numeric'
                    })}
                  </span>
                )}
              </div>
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <div style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: '2.5rem', fontWeight: 700,
                color: 'var(--red)', lineHeight: 1
              }}>
                {opp.milestoneCount}
              </div>
              <div style={{
                fontSize: '0.625rem', fontWeight: 600,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                color: 'var(--red)'
              }}>
                milestone{opp.milestoneCount !== 1 ? 's' : ''} at risk
              </div>
            </div>
          </div>
          <div style={{
            marginTop: '12px', padding: '6px 12px',
            background: '#FFF5F5', fontSize: '0.75rem',
            color: 'var(--red)', fontWeight: 600
          }}>
            Click to open Bid Plan →
          </div>
        </div>
      ))}

      <div className="actions" style={{ marginTop: '8px' }}>
        <button className="btn btn--secondary" onClick={() => onNavigate('dashboard')}>
          ← Dashboard
        </button>
      </div>
    </div>
  )
}

export default AtRiskPlans